import { fontStyles } from '../../../styles/typography';
import { classNames } from '../../../utils/classnames';

const rowBgColors = ['bg-token-gray-300', 'bg-token-gray-200', 'bg-token-gray-100'];

interface EmptyStateProps {
  hasNetworkFilter?: boolean;
  isError?: boolean;
  searchQuery?: string;
}

export function EmptyState({ hasNetworkFilter, isError, searchQuery }: EmptyStateProps) {
  const getEmptyStateMessage = () => {
    if (isError) {
      return {
        title: 'Oops! Fetching token data failed.',
        description: 'There was an error connecting to the data source. Reload to try again.',
      };
    }
    if (searchQuery) {
      return {
        title: 'No tokens found',
        description: `No tokens match "${searchQuery}" in this category. Try a different search or switch categories.`,
      };
    }
    if (hasNetworkFilter) {
      return {
        title: 'No tokens found',
        description:
          'No trending tokens are available for the selected network at this time. Try selecting a different network or check back later.',
      };
    }
    return {
      title: 'No tokens found',
      description:
        'No tokens match your current filters. Try adjusting your filters to see more results.',
    };
  };

  const { title, description } = getEmptyStateMessage();

  return (
    // Paint the same `bg-special-background-card` surface as the table itself
    // so the empty and error states blend in with the table card rather than
    // showing the darker app background of the surrounding scroll container.
    <div className="w-full h-[780px] flex flex-col items-center justify-center gap-14 bg-special-background-card">
      <div className="grid grid-cols-7 gap-4.5 w-[285px]">
        {rowBgColors.map((color, index) => (
          <div key={index} className="contents">
            <div className={classNames('col-span-1', 'rounded-full', 'h-6', color)} />
            <div className={classNames('col-span-2', 'rounded-[8px]', 'h-6', color)} />
            <div className={classNames('col-span-2', 'rounded-[8px]', 'h-6', color)} />
            <div className={classNames('col-span-2', 'rounded-[8px]', 'h-6', color)} />
          </div>
        ))}
      </div>
      <div className="w-fit max-w-md text-center">
        <h3 className={fontStyles({ variant: 'LABEL_LG', class: ['text-center'] })}>{title}</h3>
        <p className={fontStyles({ variant: 'BODY_MD', class: ['text-token-gray-700', 'mt-3'] })}>
          {description}
        </p>
      </div>
    </div>
  );
}
